import { wanjianshiBrandAssets } from './assets';

export function applyWanjianshiBranding(): void {
  const existing = document.querySelector<HTMLLinkElement>('link[rel~="icon"]');
  const favicon = existing ?? document.createElement('link');

  favicon.rel = 'icon';
  favicon.type = 'image/svg+xml';
  favicon.sizes = 'any';
  favicon.href = wanjianshiBrandAssets.faviconUrl;

  if (!existing) document.head.appendChild(favicon);
}
